(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // click-directive to show info about reminders 
    module.directive('agendaAppointmentShowReminder', ['AppointmentDetailService', function (AppointmentDetailService) {
        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                id: '=' // appointment id
            }
        };
        return directive;

        function link(scope, element) {

            // click listener
            element.on('click', function () {
                show();
            });

            // show info
            function show() {
                AppointmentDetailService.reminder(scope.id);
            } // show

            // on destroy
            scope.$on("$destroy", function () {
                element.off("click");
            });

        }
    }]);

})();